<div class="auto">
  <div class="auth-wrapper legal_mobile">
    <div class="card">

      <div class="text-center">
        <h2 class="title">Bank Account Details</h2>
        <p class="subtitle">
          Provide your bank details for payment settlements
        </p>
      </div>

      <form [formGroup]="companyForm" (ngSubmit)="submit()">

        <!-- Company Info -->
        <div class="form-group">
          <label>Account Holder Name </label>
          <input type="text" formControlName="accountName" placeholder="As per registration documents" />
          <!-- <small class="text-danger"
          *ngIf="companyForm.get('accountName')?.touched && companyForm.get('accountName')?.errors?.['required']">
          Account Holder Name is required.
        </small> -->
        </div>
        <div class="form-row">
          <div class="form-group">
            <label>Account Number</label>
            <input type="number" formControlName="accountNumber" placeholder="123456789012" />

            <!-- <small class="text-danger"
            *ngIf="companyForm.get('accountNumber')?.touched && companyForm.get('accountNumber')?.errors?.['required']">
            Account Number is required.
          </small> -->

            <!-- <small class="text-danger"
            *ngIf="companyForm.get('accountNumber')?.touched && companyForm.get('accountNumber')?.errors?.['pattern']">
            Account Number must be 9–18 digits.
          </small> -->

          </div>
          <div class="form-group">
            <label>IFSC Code</label>
            <input type="text" formControlName="ifscCode" placeholder="ABCD0123456" maxlength="11"
              (input)="onIfscInput($event)" />
            <!-- <div *ngIf="companyForm.get('ifscCode')?.touched && companyForm.get('ifscCode')?.invalid">
            <small class="text-danger" *ngIf="companyForm.get('ifscCode')?.errors?.['required']">
              IFSC is required
            </small>
            <small class="text-danger" *ngIf="companyForm.get('ifscCode')?.errors?.['pattern']">
              Invalid IFSC format (Example: SBIN0030464)
            </small>
          </div> -->
          </div>
        </div>


        <div class="form-row">
          <div class="form-group">
            <label>Bank Name</label>
            <input type="text" formControlName="bankName" placeholder="State Bank of India"
              style="text-transform: capitalize;" />
            <!-- <small class="text-danger"
            *ngIf="companyForm.get('bankName')?.touched && companyForm.get('bankName')?.errors?.['required']">
            Bank Name is required.
          </small> -->
          </div>
          <div class="form-group">
            <label>Branch Name</label>
            <input type="text" formControlName="branchName" placeholder="Mumbai Main Branch"
              style="text-transform: capitalize;" />
            <!-- <small class="text-danger"
            *ngIf="companyForm.get('branchName')?.touched && companyForm.get('branchName')?.errors?.['required']">
            Branch Name is required.
          </small> -->
          </div>
        </div>

        <div class="form-group">
          <label>Cancelled Cheque</label>
          <input type="file" (change)="onFileSelect($event)" hidden accept="image/*,application/pdf,.png,.jpg,.jpeg"
            id="panFile" />
          <div class="file-box">
            <!-- <span class="file-name">
            {{ selectedFileName || 'Choose file...' }}
          </span>

          <button type="button" class="browse-btn" (click)="triggerFile()">
            Browse
          </button> -->
            <span class="file-name" *ngIf="!formfillNext">
              <!-- {{ selectedFileName || 'Choose file...' }} -->

              {{
              selectedFileName
              ? (
              selectedFileName.length > 20
              ? (selectedFileName.slice(0,20) + '' +
              selectedFileName.slice(selectedFileName.lastIndexOf('.')))
              : selectedFileName
              )
              : 'Choose file...'
              }}
            </span>

            <!-- <span class="file-name" *ngIf="formfillNext">
            <a [href]=selectedFileName target="_blank" style="text-decoration: none;">VIEW CHEQUE</a>
          </span> -->

            <span class="file-name" *ngIf="formfillNext">

              <a *ngIf="selectedFileName; else noFile" [href]="selectedFileName" target="_blank"
                style="text-decoration: none;">
                VIEW CHEQUE
              </a>

              <ng-template #noFile>
                <span>No file available</span>
              </ng-template>

            </span>


            <button type="button" class="browse-btn" (click)="triggerFile()" *ngIf="!formfillNext">
              Browse
            </button>
          </div>
          <div class="text-danger"
            *ngIf="companyForm.get('filecheque')?.touched && companyForm.get('filecheque')?.invalid">

            <small *ngIf="companyForm.get('filecheque')?.errors?.['required']">
              Cancelled cheque is required
            </small>

            <small *ngIf="companyForm.get('filecheque')?.errors?.['invalidType']">
              Only PDF, JPG, PNG allowed
            </small>

            <small *ngIf="companyForm.get('filecheque')?.errors?.['maxSize']">
              File size must be less than 3MB
            </small>

            <small *ngIf="companyForm.get('filecheque')?.errors?.['uploadFailed']">
              File upload failed, please try again
            </small>
          </div>

        </div>
        <div class="note-box">
          <strong>Note:</strong>
          Please upload a clear image of a cancelled cheque showing account holder name, account number, IFSC code, and
          bank details. Alternatively, you can upload a bank statement or passbook front page.
        </div>

        <!-- Buttons -->
        <div class="button-row">
          <button type="button" class="secondary-btn" (click)="back()">Back</button>

          <!-- <button type="submit" class="primary-btn "> Continue </button> -->
          <button type="submit" class="primary-btn" *ngIf="!formfillNext"> Continue </button>
          <button type="button" class="primary-btn" (click)="submit()" *ngIf="formfillNext"> Next </button>
          <!-- <button type="button" class="primary-btn" (click)="next()" *ngIf="formfillNext"> Next </button> -->
        </div>
      </form>
    </div>
    <div class="step-dots"><span class="dot"></span><span class="dot"></span><span class="dot active"></span><span
        class="dot"></span><span class="dot"></span><span class="dot"></span><span class="dot"></span><span
        class="dot"></span></div>
  </div>

  <div class="logout">
    <button (click)="logout()" class="primary-btn">Logout</button>
  </div>
</div>